import Client from '@/clients/apiClient';
import { stringify } from 'query-string';

const resource = 'orders';

export default {
  get(payload) {
    const params = Object.assign(
      {
        page: payload.page,
        limit: payload.limit || 10,
      },
      payload.filter
    );
    return Client.get(`${resource}?${stringify(params)}`);
  },
  show(id) {
    return Client.get(`${resource}/${id}`);
  },
  changeStatus(id, payload) {
    return Client.post(`${resource}/${id}/change-status`, payload);
  },
};
